import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

const MainLandingPage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0)
  const [stats, setStats] = useState({ users: 0, listings: 0, connections: 0 })
  const navigate = useNavigate()

  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "Software Engineer, Dallas",
      avatar: "RK",
      quote: "Great platform to connect with fellow NRIs! Found helpful advice about rental properties in India from others who've been there.",
      rating: 5
    },
    {
      name: "Priya Sharma",
      role: "Doctor, California",
      avatar: "PS",
      quote: "Love connecting with other NRIs for visa guidance. It's helpful to get insights from those who've gone through similar processes.",
      rating: 5
    },
    {
      name: "Arjun Mehta",
      role: "Engineer, Texas",
      avatar: "AM",
      quote: "Found a travel companion for my trip to India through this platform. Great way to connect with trustworthy fellow NRIs.",
      rating: 5
    },
    {
      name: "Sunita Kapoor",
      role: "Consultant, New York",
      avatar: "SK",
      quote: "The community is supportive and helpful. Got quick answers to my questions about property investment from experienced NRIs.",
      rating: 5
    }
  ]

  // Animated counter effect
  useEffect(() => {
    const animateCounters = () => {
      const targetStats = { users: 500, listings: 200, connections: 50 }
      const duration = 500
      const steps = 60
      const stepDuration = duration / steps
      
      let currentStep = 0
      const timer = setInterval(() => {
        currentStep++
        const progress = currentStep / steps
        setStats({
          users: Math.floor(targetStats.users * progress),
          listings: Math.floor(targetStats.listings * progress),
          connections: Math.floor(targetStats.connections * progress)
        })
        
        if (currentStep >= steps) {
          clearInterval(timer)
        }
      }, stepDuration)
    }

    const timer = setTimeout(animateCounters, 500)
    return () => clearTimeout(timer)
  }, [])

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [testimonials.length])

  return (
    <div style={styles.container}>
      <style>{cssStyles}</style>

      {/* Trust Bar */}
      <div className="trust-bar">
        <div className="trust-content">
          <div className="trust-item">
            <span>🔒</span>
            <span>100% secure</span>
          </div>
          <div className="trust-item">
            <span>🤝</span>
            <span>community driven</span>
          </div>
          <div className="trust-item">
            <span>🇺🇸</span>
            <span>USA</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <span className="badge-icon">🚀</span>
                <span>Join Growing Community of USA NRIs</span>
              </div>
              <h1 className="hero-title">
                Connect with Fellow <span className="hero-accent">USA NRIs</span> for Mutual Support
              </h1>
              <p className="hero-subtitle">
                Find rentals, travel companions, get visa guidance, and connect with a supportive community of fellow NRIs in the USA. 
                <strong> All completely free - built by NRIs, for NRIs.</strong>
              </p>

              <div className="hero-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Connect with fellow NRIs for rental help</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Find travel companions for safe journeys</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Get visa guidance from experienced NRIs</span>
                </div>
              </div>

              <div className="hero-cta">
                <button className="hero-primary-btn" onClick={() => {navigate("/signUp")}}>
                  <span className="btn-text">Join Our Community</span>
                  <span className="btn-subtext">100% Free Forever</span>
                </button>
                <button className="hero-secondary-btn" onClick={() => {navigate("/login")}}>
                  Sign In
                </button>
              </div>

              <div className="hero-guarantee">
                <span className="guarantee-icon">🆓</span>
                <span>Completely Free • No Hidden Fees • Join Anytime</span>
              </div>
            </div>

            <div className="hero-visual">
              <div className="stats-container">
                <div className="stat-item">
                  <div className="stat-number">{stats.users.toLocaleString()}+</div>
                  <div className="stat-label">USA NRIs</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{stats.listings.toLocaleString()}+</div>
                  <div className="stat-label">Active Listings</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{stats.connections.toLocaleString()}+</div>
                  <div className="stat-label">Connections Made</div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar">{testimonials[currentTestimonial].avatar}</div>
                  <div className="testimonial-info">
                    <h4>{testimonials[currentTestimonial].name}</h4>
                    <p>{testimonials[currentTestimonial].role}</p>
                  </div>
                </div>
                <p className="testimonial-quote">
                  "{testimonials[currentTestimonial].quote}"
                </p>
                <div className="testimonial-rating">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#ffd700">
                      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"></polygon>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Growth Section */}
      <section className="urgency-section">
        <div className="urgency-container">
          <div className="urgency-content">
            <span className="urgency-icon">🌟</span>
            <span className="urgency-text">
              <strong>Early Adopter:</strong> Be among the first to join our growing community of USA NRIs!
            </span>
            <button className="urgency-btn" onClick={() => {navigate("/signUp")}}>
              Join Now
            </button>
          </div>
        </div>
      </section>

      {/* Problem/Solution Section */}
      <section className="problem-solution">
        <div className="problem-solution-container">
          <div className="section-header">
            <h2>Are You Tired of These NRI Struggles?</h2>
            <p>We understand your pain points and have the solutions</p>
          </div>

          <div className="problem-solution-grid">
            <div className="problem-card">
              <div className="problem-icon">😰</div>
              <h3>Struggling to find trustworthy rentals?</h3>
              <p>Dealing with unreliable landlords, hidden fees, and fake listings?</p>
            </div>
            <div className="solution-card">
              <div className="solution-icon">🏠</div>
              <h3>Verified Rentals in 24 Hours</h3>
              <p>Our team personally verifies every listing. No surprises, no hidden fees.</p>
            </div>

            <div className="problem-card">
              <div className="problem-icon">✈️</div>
              <h3>Traveling alone feels risky?</h3>
              <p>Worried about safety, language barriers, and getting lost?</p>
            </div>
            <div className="solution-card">
              <div className="solution-icon">👥</div>
              <h3>Trusted Travel Companions</h3>
              <p>Connect with verified fellow NRIs for safe, enjoyable journeys.</p>
            </div>

            <div className="problem-card">
              <div className="problem-icon">📋</div>
              <h3>Visa questions confusing?</h3>
              <p>Complex requirements, changing policies, and unclear documentation?</p>
            </div>
            <div className="solution-card">
              <div className="solution-icon">🤝</div>
              <h3>Connect with Experienced NRIs</h3>
              <p>Get guidance from fellow NRIs who've been through the same process.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="features-container">
          <div className="section-header">
            <h2>Why Join Our Community?</h2>
            <p>Built by NRIs, for NRIs. We understand your unique challenges and connect you with fellow NRIs who can help.</p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#021138" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3>Community-Driven</h3>
              <p>Connect with fellow NRIs who understand your journey. Get advice, share experiences, and build lasting relationships.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#021138" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3>Safe & Secure</h3>
              <p>All members are verified USA NRIs. Your safety and privacy are our top priorities.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#021138" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <h3>USA-Focused</h3>
              <p>Designed specifically for NRIs living in the USA. Connect with others who understand your unique challenges and experiences.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="services-container">
          <div className="section-header">
            <h2>What You Can Do</h2>
            <p>Connect with fellow USA NRIs for mutual support and assistance</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9,22 9,12 15,12 15,22"></polyline>
                </svg>
              </div>
              <h3>Home Rentals</h3>
              <p>Connect with fellow NRIs to find rental properties in India. Get recommendations and advice from those who've been there.</p>
              <button className="service-btn" onClick={() => {navigate("/signUp")}}>Join Community</button>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
                </svg>
              </div>
              <h3>Travel Companions</h3>
              <p>Find fellow NRIs for safe, enjoyable journeys between USA and India. Travel together and share experiences.</p>
              <button className="service-btn" onClick={() => {navigate("/signUp")}}>Join Community</button>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10,9 9,9 8,9"></polyline>
                </svg>
              </div>
              <h3>Visa Guidance</h3>
              <p>Get help with visa questions from fellow NRIs who've been through the process. Share experiences and get guidance.</p>
              <button className="service-btn" onClick={() => {navigate("/signUp")}}>Join Community</button>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
              </div>
              <h3>Commerce & Trade</h3>
              <p>Buy and sell cars, electronics, and other goods within the USA NRI community. Trusted transactions with fellow NRIs.</p>
              <button className="service-btn" onClick={() => {navigate("/signUp")}}>Join Community</button>
            </div>
          </div>

          <div className="services-cta">
            <button className="btn-accent" onClick={()=>{navigate("/signUp")}}>
              Join Our Community
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12,5 19,12 12,19"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="social-proof">
        <div className="social-proof-container">
          <div className="section-header">
            <h2>Join Our Growing Community</h2>
            <p>Connect with fellow USA NRIs who are already helping each other</p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card-full">
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#ffd700">
                      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"></polygon>
                    </svg>
                  ))}
                </div>
                <p>"{testimonial.quote}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.avatar}</div>
                  <div className="author-info">
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="social-proof-stats">
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Free Forever</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24hrs</div>
              <div className="stat-label">Average Response Time</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">🇺🇸</div>
              <div className="stat-label">USA Focused</div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="cta">
        <div className="cta-container">
          <div className="cta-content">
            <h2>Ready to Connect with Fellow USA NRIs?</h2>
            <p>
              Join our growing community of USA NRIs who are helping each other with rentals, travel, visa guidance, and more. 
              All completely free - built by NRIs, for NRIs.
            </p>
            
            <div className="cta-buttons">
              <button className="cta-primary-btn" onClick={()=>{navigate("/signUp")}}>
                <span className="btn-text">Join Our Community</span>
                <span className="btn-subtext">100% Free Forever</span>
              </button>
              <button className="cta-secondary-btn" onClick={()=>{navigate("/login")}}>
                Sign In
              </button>
            </div>

            <div className="cta-guarantee">
              <span className="guarantee-icon">🆓</span>
              <span>Completely Free • No Hidden Fees • Join Anytime</span>
            </div>

            <div className="cta-social-proof">
              <p>Currently serving USA NRIs • Growing community daily</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "white",
  },
}

const cssStyles = `
  /* Reset and Base Styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
    line-height: 1.6;
    color: #333;
  }

  /* Trust Bar */
  .trust-bar {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    padding: 2px 0;
    font-size: 14px;
  }

  .trust-content {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    flex-wrap: wrap;
  }

  .trust-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #495057;
    font-weight: 500;
  }

  .trust-icon {
    font-size: 16px;
  }

  /* Hero Section */
  .hero {
    background: linear-gradient(135deg, #021138 0%, #1a237e 100%);
    color: white;
    padding: 4rem 0 6rem;
    position: relative;
    overflow: hidden;
  }

  .hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.1"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    pointer-events: none;
  }

  .hero-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
    position: relative;
    z-index: 1;
  }

  .hero-content {
    display: grid;
    gap: 3rem;
    align-items: center;
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 215, 0, 0.1);
    border: 1px solid rgba(255, 215, 0, 0.3);
    padding: 0.5rem 1rem;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 1.5rem;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }

  .badge-icon {
    font-size: 16px;
  }

  .hero-title {
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  .hero-accent {
    color: #ffd700;
    position: relative;
  }

  .hero-accent::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }

  .hero-subtitle {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  .hero-benefits {
    margin-bottom: 1.5rem;
  }

  .benefit-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.9);
  }

  .benefit-icon {
    width: 16px;
    height: 16px;
    background: #ffd700;
    color: #021138;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
  }

  .hero-cta {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .hero-primary-btn {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #021138;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  }

  .hero-primary-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  }

  .btn-text {
    font-size: 1rem;
    font-weight: 600;
  }

  .btn-subtext {
    font-size: 0.8rem;
    font-weight: 500;
    opacity: 0.8;
  }

  .hero-secondary-btn {
    background: transparent;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .hero-secondary-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }

  .hero-guarantee {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
  }

  .guarantee-icon {
    font-size: 14px;
  }

  .hero-visual {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .stats-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
    background: rgba(255, 255, 255, 0.1);
    padding: 1rem;
    border-radius: 8px;
    backdrop-filter: blur(10px);
  }

  .stat-item {
    text-align: center;
  }

  .stat-number {
    font-size: 1.5rem;
    font-weight: bold;
    color: #ffd700;
    margin-bottom: 0.25rem;
  }

  .stat-label {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.8);
  }

  .testimonial-card {
    background: white;
    color: #021138;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: slideInUp 0.6s ease-out;
  }

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .testimonial-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }

  .testimonial-avatar {
    width: 2.5rem;
    height: 2.5rem;
    background: #ffd700;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #021138;
    font-size: 0.8rem;
  }

  .testimonial-info h4 {
    font-weight: 600;
    margin-bottom: 0.25rem;
    font-size: 0.9rem;
  }

  .testimonial-info p {
    font-size: 0.75rem;
    color: #6b7280;
  }

  .testimonial-quote {
    color: #374151;
    font-style: italic;
    margin-bottom: 0.75rem;
    line-height: 1.5;
    font-size: 0.85rem;
  }

  .testimonial-rating {
    display: flex;
    gap: 0.25rem;
  }

  /* Urgency Section */
  .urgency-section {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
    padding: 1rem 0;
    text-align: center;
  }

  .urgency-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .urgency-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .urgency-icon {
    font-size: 20px;
    animation: flash 1s infinite;
  }

  @keyframes flash {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  .urgency-text {
    font-size: 1rem;
    font-weight: 600;
  }

  .urgency-btn {
    background: #ffd700;
    color: #021138;
    border: none;
    padding: 0.4rem 1rem;
    border-radius: 4px;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .urgency-btn:hover {
    background: #e6c200;
    transform: scale(1.02);
  }

  /* Problem/Solution Section */
  .problem-solution {
    padding: 3rem 0;
    background: #f8f9fa;
  }

  .problem-solution-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .section-header {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  .section-header h2 {
    font-size: 1.75rem;
    font-weight: bold;
    color: #021138;
    margin-bottom: 0.75rem;
  }

  .section-header p {
    font-size: 1rem;
    color: #6b7280;
    max-width: 48rem;
    margin: 0 auto;
  }

  .problem-solution-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .problem-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;
    text-align: center;
    transition: all 0.3s ease;
  }

  .problem-card:hover {
    border-color: #dc3545;
    transform: translateY(-1px);
  }

  .problem-icon {
    font-size: 2rem;
    margin-bottom: 0.75rem;
  }

  .problem-card h3 {
    font-size: 1rem;
    font-weight: bold;
    color: #dc3545;
    margin-bottom: 0.75rem;
  }

  .problem-card p {
    color: #6b7280;
    font-size: 0.9rem;
  }

  .solution-card {
    background: linear-gradient(135deg, #021138, #1a237e);
    color: white;
    border-radius: 8px;
    padding: 1.5rem;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .solution-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05));
    pointer-events: none;
  }

  .solution-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(2, 17, 56, 0.3);
  }

  .solution-icon {
    font-size: 2rem;
    margin-bottom: 0.75rem;
    color: #ffd700;
  }

  .solution-card h3 {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    position: relative;
    z-index: 1;
  }

  .solution-card p {
    position: relative;
    z-index: 1;
    opacity: 0.9;
    font-size: 0.9rem;
  }

  /* Features Section */
  .features {
    padding: 5rem 0;
    background: white;
  }

  .features-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .features-grid {
    display: grid;
    gap: 2rem;
  }

  .feature-card {
    background: white;
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .feature-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #ffd700, #ffed4e);
  }

  .feature-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .feature-icon {
    width: 4rem;
    height: 4rem;
    background: #ffd700;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
    transition: all 0.3s ease;
  }

  .feature-card:hover .feature-icon {
    transform: scale(1.1);
  }

  .feature-card h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #021138;
    margin-bottom: 1rem;
  }

  .feature-card p {
    color: #6b7280;
    line-height: 1.6;
  }

  /* Services Section */
  .services {
    padding: 5rem 0;
    background: linear-gradient(135deg, #021138, #1a237e);
    color: white;
  }

  .services-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .services .section-header h2 {
    color: white;
  }

  .services .section-header p {
    color: rgba(255, 255, 255, 0.8);
  }

  .services-grid {
    display: grid;
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .service-card {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
  }

  .service-card:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #ffd700;
    transform: translateY(-3px);
  }

  .service-icon {
    width: 3rem;
    height: 3rem;
    background: #ffd700;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
    transition: all 0.3s ease;
  }

  .service-card:hover .service-icon {
    transform: scale(1.1);
  }

  .service-card h3 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .service-card p {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .service-btn {
    background: #ffd700;
    color: #021138;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
  }

  .service-btn:hover {
    background: #e6c200;
    transform: scale(1.02);
  }

  .services-cta {
    text-align: center;
  }

  .btn-accent {
    background: #ffd700;
    color: #021138;
    border: none;
    padding: 0.6rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
  }

  .btn-accent:hover {
    background: #e6c200;
    transform: translateY(-1px);
  }

  /* Social Proof Section */
  .social-proof {
    padding: 5rem 0;
    background: #f8f9fa;
  }

  .social-proof-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .testimonials-grid {
    display: grid;
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .testimonial-card-full {
    background: white;
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    transition: all 0.3s ease;
  }

  .testimonial-card-full:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }

  .testimonial-card-full .testimonial-rating {
    display: flex;
    gap: 0.25rem;
    margin-bottom: 1rem;
  }

  .testimonial-card-full p {
    color: #374151;
    font-style: italic;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .testimonial-author {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding-top: 1rem;
    border-top: 1px solid #e9ecef;
  }

  .author-avatar {
    width: 2.5rem;
    height: 2.5rem;
    background: #ffd700;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #021138;
    font-size: 0.875rem;
  }

  .author-info h4 {
    font-weight: 600;
    color: #021138;
    margin-bottom: 0.25rem;
  }

  .author-info p {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
  }

  .social-proof-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  .social-proof-stats .stat-item {
    text-align: center;
  }

  .social-proof-stats .stat-number {
    font-size: 2.5rem;
    font-weight: bold;
    color: #ffd700;
    margin-bottom: 0.5rem;
  }

  .social-proof-stats .stat-label {
    font-size: 1rem;
    color: #6b7280;
    font-weight: 600;
  }

  /* CTA Section */
  .cta {
    padding: 5rem 0;
    background: linear-gradient(135deg, #021138, #1a237e);
    color: white;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .cta::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="cta-grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.05"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.05"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.05"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.05"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23cta-grain)"/></svg>');
    pointer-events: none;
  }

  .cta-container {
    max-width: 64rem;
    margin: 0 auto;
    padding: 0 1rem;
    position: relative;
    z-index: 1;
  }

  .cta-content h2 {
    font-size: 2.25rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .cta-content p {
    font-size: 1.25rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
    margin-bottom: 2rem;
  }

  .cta-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    margin-bottom: 2rem;
  }

  .cta-primary-btn {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #021138;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  }

  .cta-primary-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  }

  .cta-secondary-btn {
    background: transparent;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0.6rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .cta-secondary-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }

  .cta-guarantee {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1rem;
  }

  .cta-social-proof {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
  }

  /* Responsive Design */
  @media (min-width: 640px) {
    .hero-title {
      font-size: 2.25rem;
    }

    .hero-cta {
      flex-direction: row;
      align-items: center;
    }

    .hero-primary-btn {
      flex: 1;
    }

    .hero-secondary-btn {
      flex: 0 0 auto;
    }

    .cta-buttons {
      flex-direction: row;
      justify-content: center;
    }

    .cta-primary-btn {
      flex: 0 0 auto;
    }

    .cta-secondary-btn {
      flex: 0 0 auto;
    }
  }

  @media (min-width: 768px) {
    .trust-content {
      justify-content: space-around;
    }

    .hero-content {
      grid-template-columns: repeat(2, 1fr);
    }

    .hero-title {
      font-size: 2.5rem;
    }

    .problem-solution-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .features-grid {
      grid-template-columns: repeat(3, 1fr);
    }

    .services-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .testimonials-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .social-proof-stats {
      grid-template-columns: repeat(3, 1fr);
    }

    .cta-content h2 {
      font-size: 3rem;
    }
  }

  @media (min-width: 1024px) {
    .services-grid {
      grid-template-columns: repeat(4, 1fr);
    }

    .testimonials-grid {
      grid-template-columns: repeat(3, 1fr);
    }

    .hero-title {
      font-size: 2.75rem;
    }

    .cta-content h2 {
      font-size: 2.5rem;
    }
  }

  @media (min-width: 1280px) {
    .hero-container,
    .problem-solution-container,
    .features-container,
    .services-container,
    .social-proof-container,
    .cta-container {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  /* Mobile Optimizations */
  @media (max-width: 767px) {
    .trust-content {
      flex-direction: row;
      gap: 1rem;
      justify-content: center;
      flex-wrap: nowrap;
    }

    .trust-item {
      font-size: 12px;
      white-space: nowrap;
    }

    .urgency-content {
      flex-direction: column;
      gap: 0.5rem;
    }

    .problem-solution-grid {
      grid-template-columns: 1fr;
    }

    .hero-title {
      font-size: 2rem;
    }

    .hero-subtitle {
      font-size: 1rem;
    }

    .stats-container {
      grid-template-columns: repeat(3, 1fr);
      gap: 0.5rem;
      padding: 0.75rem;
    }

    .stat-number {
      font-size: 1rem;
      margin-bottom: 0.15rem;
    }

    .stat-label {
      font-size: 0.65rem;
    }

    .social-proof-stats {
      grid-template-columns: repeat(3, 1fr);
      gap: 0.5rem;
      padding: 1rem;
    }

    .social-proof-stats .stat-number {
      font-size: 1.25rem;
      margin-bottom: 0.25rem;
    }

    .social-proof-stats .stat-label {
      font-size: 0.7rem;
    }
  }
`

export default MainLandingPage